import config from './routes.json'
export {
    AWSCOGNITO_API,
    AWSCOGNITO_CLIENTID,
    AWSCOGNITO_USERPOOLID,
    BOM_WEATHER_API,
    ENVPRE,
    FARMDECK_API,
    FIREBASE_CONFIG,
    FIREBASE_VAPID_KEY,
    FIREBASE_PROXY_API,
    GISSERVICE_API,
    GOOGLE_API,
    GOOGLE_MAPS_VERSION,
    GOOGLE_MAP_ID,
    GOOGLE_STATIC,
    GOOGLE_STREETVIEW,
    ARCGIS_ENABLED,
    ARCGIS_KOOP_API,
    IP_ADDRESS_API,
    is_development,
    is_local_host,
    is_mobile_build,
    is_prod_env,
    is_prod_host,
    is_test_env,
    MAINTENANCE_MODE,
    PAYMENTS_API,
    PLANNER_API,
    RESOURCE_API,
    STRIPE_PUBLISHABLE_KEY,
    TASKMANAGER_API,
    TIME_LIMIT_FOR_FETCH,
    TIME_LIMIT_FOR_FETCH_12HR,
    VIDEO_SURVEILLANCE_API,
    WEATHER_API,
} from './config.js'

export const metadata = config.metadata
